import React, { useEffect } from 'react';

import { Container, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import OrdersSummaryStats from './components/OrdersSummaryStats';
import OrdersTableContainer from './components/OrdersTableContainer';
import { useTimezone } from 'contexts/TimezoneContext';
import { getOrdersOverviewApi } from 'features/orders/orders.api';
import { useColors } from './components/colors';

const defaultOverview = {
  totalOrders: 0,
  awaitingShipment: 0,
  shippedToday: 0,
  ebayOrders: 0,
  amazonOrders: 0,
  totalRevenue: 0,
  totalQuantitySold: 0,
  avgOrderValue: 0,
  revenuePeriodDays: 30,
};

const Orders = () => {
  const dispatch = useDispatch();
  const { timezone } = useTimezone();
  const { mutedTextColor } = useColors();
  const { overview, getOverviewStatus } = useSelector((s) => s.orders);

  useEffect(() => {
    dispatch(getOrdersOverviewApi({ revenueDays: 30 }));
  }, [dispatch]);

  return (
    <Container maxW="container.2xl" py={8} mt="50px">
      <Flex justify="space-between" align="flex-start" mb={6} flexWrap="wrap" gap={4}>
        <VStack align="start" spacing={1}>
          <Heading size="lg">Orders</Heading>
          <Text fontSize="sm" color={mutedTextColor} maxW="640px">
            Centralized view of marketplace orders — fulfillment status, payments, line items,
            shipping, and buyer data from eBay Fulfillment API and Amazon SP-API.
          </Text>
        </VStack>
      </Flex>

      <VStack align="stretch" spacing={8}>
        <OrdersSummaryStats
          overview={overview || defaultOverview}
          loading={getOverviewStatus === 'pending'}
        />
        <OrdersTableContainer key={timezone} />
      </VStack>
    </Container>
  );
};

export default Orders;
